/* src/app/components/elibraryandcourse/e-library/e-library.component.scss */
:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
}
ng-select {
  width: 35%;
}
.second-level-menu {
  max-width: 280px;
  min-width: 280px;
}
.add-new-documents-wrapper {
  display: flex;
  align-items: center;
}
.add-new-documents {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 20px;
  white-space: nowrap;
}
.add-new-documents .button-text {
  display: inline;
}
.add-new-documents img {
  filter: brightness(0) invert(1);
}
.list-wrapper ul.notification-list li {
  min-height: 38px;
  color: var(--textsecondarycolor) !important;
  font-size: 14px;
}
.list-wrapper ul.notification-list li .icon {
  display: block !important;
}
.list-wrapper ul.notification-list li:not(.active) .fa-folder-open {
  display: none;
}
.list-wrapper ul.notification-list li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-right: 3px solid #253B80;
  border-radius: 7px;
  font-weight: 600;
}
.list-wrapper ul.notification-list li.active .fa-folder {
  display: none;
}
.list-wrapper ul.notification-list li.active .list-active,
.list-wrapper ul.notification-list li.active .lesson {
  color: var(--listcolor) !important;
}
.list-wrapper ul.notification-list li:hover {
  background: var(--listbackgoundhover) !important;
}
.elibrary-list li .is-one-quarter {
  width: 12% !important;
}
#library-card-list {
  width: 100%;
  height: 150px;
  display: none;
  overflow-y: auto;
  scrollbar-width: none;
}
#library-card-list .notification-list {
  width: 100%;
}
#library-card-list .notification-list .card {
  width: 245px;
  background: #fff;
  border-radius: 10px;
  float: left;
  margin: 5px;
}
#library-card-list .notification-list .card .card-body {
  padding: 0.4rem 0.65rem;
}
#library-card-list .notification-list .card .card-body label {
  font-size: 14px;
  color: #475569;
}
#library-card-list .notification-list .card .icon {
  display: none;
}
#library-card-list .notification-list .card.active {
  background: var(--primarylightColor);
  color: #fff;
}
#library-card-list .notification-list .card.active .card-body label {
  color: var(--primaryColor);
}
#library-card-list .notification-list .card.active .icon {
  display: block;
}
.documents-header {
  width: 100%;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
}
.documents-header__left {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 13px;
}
.documents-header__icon {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef4ff;
  color: #253B80;
  border-radius: 11px;
}
.documents-header__icon i {
  font-size: 19px;
}
.documents-header__title {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.documents-header__title h3 {
  margin: 0;
  color: #111827;
  font-size: 21px;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.2px;
}
.documents-header__subtitle {
  color: #6B7280;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 400;
}
.documents-header__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
}
.documents-search {
  position: relative;
  width: 270px;
  height: 42px;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}
.documents-search > i {
  margin-left: 13px;
  color: #94a3b8;
  font-size: 15px;
  pointer-events: none;
}
.documents-search input {
  width: 100%;
  height: 100%;
  padding: 0 40px 0 10px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #1e293b;
  font-size: 14px;
  font-weight: 400;
}
.documents-search input::placeholder {
  color: #9ca3af;
}
.documents-search:focus-within {
  background: #fff;
  border-color: #253B80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.documents-search__clear {
  position: absolute;
  right: 8px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
}
.documents-search__clear:hover {
  background: #e9eef5;
  color: #334155;
}
.documents-search__clear i {
  font-size: 12px;
}
.add-document-btn {
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 17px;
  border: 0;
  border-radius: 9px;
  background: #253B80;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 3px 8px rgba(37, 59, 128, 0.18);
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.add-document-btn i {
  font-size: 14px;
}
.add-document-btn:hover {
  background: #344F91;
  box-shadow: 0 5px 14px rgba(37, 59, 128, 0.24);
  transform: translateY(-1px);
}
.add-document-btn:active {
  transform: translateY(0);
}
.documents-layout {
  width: 100%;
  height: calc(100vh - 126px);
  display: flex;
  gap: 18px;
  overflow: hidden;
  background: #F4F6FA;
  padding: 0 24px;
}
.library-sidebar {
  position: relative;
  width: 290px;
  min-width: 290px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.045);
  overflow: hidden;
  transition:
    width 0.25s ease,
    min-width 0.25s ease,
    transform 0.25s ease,
    opacity 0.25s ease;
}
.library-sidebar--hidden {
  width: 0;
  min-width: 0;
  opacity: 0;
  border: 0;
  box-shadow: none;
  overflow: hidden;
}
.library-sidebar {
}
.library-sidebar--open {
  transform: translateX(0);
}
.library-sidebar {
}
.library-sidebar__header {
  min-height: 70px;
  padding: 14px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eef2f7;
}
.library-sidebar__heading {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}
.library-sidebar__icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eef4ff;
  color: #253B80;
}
.library-sidebar__icon i {
  font-size: 17px;
}
.library-sidebar__heading h4 {
  margin: 0 0 3px;
  color: #111827;
  font-size: 15px;
  line-height: 1.3;
  font-weight: 700;
}
.library-sidebar__heading span {
  color: #6B7280;
  font-size: 12px;
  line-height: 1.3;
}
.library-sidebar__mobile-header {
  display: none;
}
.sidebar-search-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #667085;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease;
}
.sidebar-search-btn i {
  font-size: 14px;
}
.sidebar-search-btn:hover {
  background: #f2f5fa;
  border-color: #d8dee8;
  color: #253B80;
}
.library-search {
  min-height: 62px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #eef2f7;
}
.library-search__input {
  position: relative;
  flex: 1;
  height: 40px;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.library-search__input > i {
  margin-left: 12px;
  color: #98a2b3;
  font-size: 13px;
}
.library-search__input input {
  width: 100%;
  height: 100%;
  padding: 0 34px 0 9px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #344054;
  font-size: 13px;
}
.library-search__input input::placeholder {
  color: #9ca3af;
}
.library-search__input:focus-within {
  background: #fff;
  border-color: #253B80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.07);
}
.library-search__clear {
  position: absolute;
  right: 7px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #98a2b3;
  cursor: pointer;
}
.library-search__clear i {
  font-size: 11px;
}
.library-search__clear:hover {
  background: #e9edf3;
  color: #475467;
}
.library-search__close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #98a2b3;
  cursor: pointer;
}
.library-search__close i {
  font-size: 13px;
}
.library-search__close:hover {
  color: #ef4444;
}
.library-toolbar {
  min-height: 52px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eef2f7;
}
.library-sort {
  position: relative;
  height: 34px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 0 9px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  color: #667085;
}
.library-sort i:first-child {
  font-size: 12px;
}
.library-sort i:last-child {
  font-size: 9px;
}
.library-sort select {
  appearance: none;
  padding-right: 3px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #475467;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}
.library-count {
  min-width: 28px;
  height: 26px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background: #eef4ff;
  color: #253B80;
  font-size: 12px;
  font-weight: 700;
}
.library-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 9px;
}
.library-list__items {
  margin: 0;
  padding: 0;
  list-style: none;
}
.library-list::-webkit-scrollbar {
  width: 6px;
}
.library-list::-webkit-scrollbar-track {
  background: transparent;
}
.library-list::-webkit-scrollbar-thumb {
  background: #d8dee8;
  border-radius: 10px;
}
.library-list {
  scrollbar-width: thin;
}
.library-item {
  position: relative;
  margin-bottom: 5px;
  list-style: none;
  border-radius: 10px;
  transition: background 0.2s ease, transform 0.2s ease;
}
.library-item__content {
  min-height: 62px;
  padding: 9px 10px;
  display: flex;
  align-items: center;
  gap: 11px;
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.library-item {
}
.library-item__icon {
  width: 39px;
  height: 39px;
  flex: 0 0 39px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #fff7e6;
  color: #e99a16;
}
.library-item__icon i {
  font-size: 17px;
}
.library-item__icon .folder-open {
  display: none;
}
.library-item {
}
.library-item__details {
  min-width: 0;
  flex: 1;
}
.library-item__name {
  overflow: hidden;
  color: #344054;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: color 0.2s ease;
}
.library-item__meta {
  margin-top: 4px;
  color: #8b95a7;
  font-size: 12px;
  line-height: 1.3;
}
.library-item {
}
.library-item__delete {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #98a2b3;
  opacity: 0;
  visibility: hidden;
  cursor: pointer;
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease,
    background 0.2s ease,
    color 0.2s ease;
}
.library-item__delete i {
  font-size: 13px;
}
.library-item__delete:hover {
  background: #fff0f0;
  color: #ef4444;
}
.library-item {
}
.library-item:hover .library-item__content {
  background: #f8faff;
  border-color: #e4ebf8;
}
.library-item:hover .library-item__name {
  color: #253B80;
}
.library-item:hover .library-item__delete {
  opacity: 1;
  visibility: visible;
}
.library-item:hover .folder-closed {
  display: none;
}
.library-item:hover .folder-open {
  display: block;
}
.library-item {
}
.library-item.active .library-item__content {
  background: #eef4ff;
  border-color: #dbe6ff;
}
.library-item.active .library-item__name {
  color: #253B80;
  font-weight: 700;
}
.library-item.active .library-item__icon {
  background: #dfeaff;
  color: #253B80;
}
.library-item.active .folder-closed {
  display: none;
}
.library-item.active .folder-open {
  display: block;
}
.library-item {
}
.library-item--inactive {
  opacity: 0.55;
}
.library-item--inactive .library-item__content {
  cursor: default;
}
.library-empty {
  min-height: 280px;
  padding: 35px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #98a2b3;
}
.library-empty__icon {
  width: 58px;
  height: 58px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  background: #f2f4f7;
  color: #98a2b3;
}
.library-empty__icon i {
  font-size: 23px;
}
.library-empty strong {
  color: #475467;
  font-size: 14px;
  font-weight: 600;
}
.library-empty span {
  max-width: 210px;
  margin-top: 6px;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.55;
}
.documents-content {
  position: relative;
  flex: 1;
  min-width: 0;
  height: 100%;
  overflow: hidden;
  transition: padding 0.25s ease;
}
.documents-content--expanded {
  width: 100%;
}
.documents-router {
  width: 100%;
  overflow: auto;
}
.documents-empty {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  pointer-events: none;
}
.documents-empty__card {
  width: min(400px, 100%);
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.06);
}
.documents-empty__icon {
  width: 68px;
  height: 68px;
  margin-bottom: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: #eef4ff;
  color: #253B80;
}
.documents-empty__icon i {
  font-size: 27px;
}
.documents-empty h4 {
  margin: 0 0 8px;
  color: #111827;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 700;
}
.documents-empty p {
  margin: 0;
  color: #7b8798;
  font-size: 14px;
  line-height: 1.65;
}
.notification-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.notification-list li.chat-list {
  position: relative;
  padding: 0.7rem 0.85rem;
  border-radius: 7px;
  transition: background 0.2s ease;
}
.notification-list li.chat-list:hover {
  background: #f9fafb;
}
.notification-list li.chat-list:hover .delete-icon {
  opacity: 1;
  visibility: visible;
}
.notification-list li.chat-list .delete-icon {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
  cursor: pointer;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}
.notification-list li.chat-list .delete-icon i {
  color: #d9534f !important;
  font-size: 14px;
}
.notification-list li.chat-list .delete-icon:hover i {
  color: #c9302c !important;
}
.notification-list li.chat-list .user-count {
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 13px;
  color: #666;
}
.mobile-sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #eef2f7;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
}
.mobile-sidebar-header h4 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  flex: 1;
}
.mobile-sidebar-header .mobile-close-btn {
  background: transparent;
  border: 0;
  font-size: 18px;
  color: #667085;
  cursor: pointer;
  padding: 0.5rem;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: background 0.2s;
}
.mobile-sidebar-header .mobile-close-btn:hover,
.mobile-sidebar-header .mobile-close-btn:active {
  background: #f1f3f5;
}
.mobile-menu-toggle {
  display: flex !important;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  margin-left: 0.5rem;
  background: #f5f7fa;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  transition: background 0.2s;
  cursor: pointer;
}
.mobile-menu-toggle:hover,
.mobile-menu-toggle:active {
  background: #e9eef5;
}
.mobile-menu-toggle i {
  font-size: 17px;
}
.sidebar-overlay {
  display: none;
}
@media screen and (max-width: 945px) {
  .documents-layout {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: calc(100vh - 70px);
    padding: 0;
    gap: 0;
    overflow: hidden;
  }
  .library-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: min(320px, 88vw);
    min-width: min(320px, 88vw);
    height: 100dvh;
    z-index: 1100;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 0;
    border-radius: 0 16px 16px 0;
    box-shadow: 12px 0 35px rgba(15, 23, 42, 0.16);
    overflow: hidden;
    transform: translate3d(-105%, 0, 0);
    opacity: 1;
    visibility: hidden;
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.28s ease;
    will-change: transform;
  }
  .library-sidebar--open {
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }
  .library-sidebar--hidden {
    width: min(320px, 88vw);
    min-width: min(320px, 88vw);
    opacity: 1;
    border: 0;
    box-shadow: 12px 0 35px rgba(15, 23, 42, 0.16);
    transform: translate3d(-105%, 0, 0);
    visibility: hidden;
  }
  .library-sidebar__header {
    display: none;
  }
  .library-sidebar__mobile-header {
    min-height: 66px;
    flex: 0 0 66px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background: #fff;
    border-bottom: 1px solid #edf0f4;
    position: relative;
    z-index: 5;
  }
  .library-sidebar__mobile-title-wrapper {
    min-width: 0;
    flex: 1;
  }
  .library-sidebar__mobile-title {
    display: block;
    margin: 0;
    color: #111827;
    font-size: 15px;
    line-height: 1.3;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .library-sidebar__mobile-subtitle {
    display: block;
    margin-top: 3px;
    color: #6B7280;
    font-size: 12px;
    line-height: 1.3;
  }
  .sidebar-close-btn {
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e4e7ec;
    border-radius: 10px;
    background: #f8fafc;
    color: #667085;
    cursor: pointer;
    transition:
      background 0.2s ease,
      color 0.2s ease,
      transform 0.15s ease;
    -webkit-tap-highlight-color: transparent;
  }
  .sidebar-close-btn:hover {
    background: #f1f5f9;
    color: #253B80;
  }
  .sidebar-close-btn:active {
    transform: scale(0.94);
  }
  .sidebar-close-btn i {
    font-size: 14px;
  }
  .library-search,
  .library-toolbar,
  .library-list {
    flex-shrink: 0;
  }
  .library-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .sidebar-overlay {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100dvh;
    display: block;
    background: rgba(15, 23, 42, 0.42);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.25s ease, visibility 0.25s ease;
  }
  .sidebar-overlay.show,
  .sidebar-overlay.active {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
  .mobile-menu-toggle {
    min-width: 44px;
    min-height: 44px;
    width: 44px;
    height: 44px;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    margin-left: 0.5rem;
    padding: 0;
    border: 1px solid #e2e8f0;
    border-radius: 9px;
    background: #fff;
    color: #253B80;
    box-shadow: 0 2px 7px rgba(15, 23, 42, 0.06);
    cursor: pointer;
    transition:
      background 0.2s ease,
      border-color 0.2s ease,
      transform 0.15s ease;
    -webkit-tap-highlight-color: transparent;
  }
  .mobile-menu-toggle:hover {
    background: #f5f8ff;
    border-color: rgba(37, 59, 128, 0.2);
  }
  .mobile-menu-toggle:active {
    transform: scale(0.95);
  }
  .mobile-menu-toggle i {
    font-size: 16px;
  }
  .documents-content {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: 100%;
    flex: 1;
    overflow: hidden;
  }
  .documents-layout,
  .documents-content {
    box-sizing: border-box;
  }
}
@media screen and (min-width: 768px) and (max-width: 945px) {
  .library-sidebar {
    width: 340px;
    min-width: 340px;
  }
}
@media screen and (max-width: 767px) {
  .library-sidebar {
    width: min(310px, 88vw);
    min-width: min(310px, 88vw);
  }
  .documents-layout {
    height: calc(100dvh - 65px);
  }
}
@media screen and (max-width: 480px) {
  .library-sidebar {
    width: min(290px, 88vw);
    min-width: min(290px, 88vw);
    border-radius: 0 14px 14px 0;
  }
  .library-sidebar__mobile-header {
    min-height: 62px;
    flex-basis: 62px;
    padding: 9px 12px;
  }
  .sidebar-close-btn {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
  .mobile-menu-toggle {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    margin-left: 4px;
  }
}
@media screen and (max-width: 360px) {
  .library-sidebar {
    width: 100%;
    min-width: 100%;
    border-radius: 0;
  }
  .sidebar-close-btn {
    width: 36px;
    height: 36px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .library-sidebar,
  .sidebar-overlay,
  .mobile-menu-toggle,
  .sidebar-close-btn {
    transition: none !important;
  }
}
/*# sourceMappingURL=e-library.component.css.map */
